'use client'

import { SupportUsMessage } from '@/components/common/SupportUs'
import { useAds } from '@/components/providers/AdsProvider'

import styles from './SidebarAd.module.scss'

export const SidebarAd = () => {
  const { sidebarDisabled } = useAds()

  if (sidebarDisabled) return null

  const className = 'mvSidebar1'

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={className} />
        <SupportUsMessage />
      </div>
    </div>
  )
}
